var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{isNewVersion: _vm.isNewVersion},attrs:{"id":"app"}},[(_vm.CUX_INT_HELP.length > 0)?_c('feed-back'):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }